import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ChevronDown } from 'lucide-react';

const AboutUs = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [coursesOpen, setCoursesOpen] = useState(false);

  return (
    <div className="bg-[#f7f6f3] text-gray-800 font-sans">
      {/* Header Bar */}
      <div className="bg-[#333] text-white text-sm py-2 px-4 flex flex-col md:flex-row md:justify-between items-center gap-2 text-center">
        <div className="flex flex-col md:flex-row items-center gap-2">
          <a href="mailto:admin@kentacademy.co.uk" className="hover:underline">
            📧 admin@kentacademy.co.uk
          </a>
        </div>
        <a
          href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:underline flex items-center gap-1"
        >
          <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
          facebook.com/KentAcademy
        </a>
      </div>

      {/* Navigation */}
      <nav className="bg-white shadow-sm w-full z-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 pt-6 pb-4 flex items-center justify-center">
        <Link to="/" className="cursor-pointer">
  <img
    src="/assets/KaLogo.png"
    alt="Kent Academy"
    className="h-40 w-auto object-contain"
  />
</Link>

        </div>
        
        {/* Desktop Nav */}
        <div className="bg-[#f7f6f3] border-t border-gray-200 hidden md:flex">
          <div className="max-w-4xl mx-auto px-4 flex justify-between items-center text-sm font-medium py-3 relative w-full">
            <Link to="/" className="text-gray-800 hover:text-black transition-colors duration-200">HOME</Link>
            <Link to="/about" className="text-gray-800 hover:text-black transition-colors duration-200">ABOUT US</Link>
            
            <div
              className="relative cursor-pointer group"
              onMouseEnter={() => setCoursesOpen(true)}
              onMouseLeave={() => setCoursesOpen(false)}
            >
              <div className="flex items-center gap-1 text-gray-800 hover:text-black transition-colors duration-200 cursor-pointer">
                <span>ALL COURSES</span>
                <ChevronDown 
                  size={16} 
                  className={`transition-transform duration-200 ${coursesOpen ? 'rotate-180' : ''}`}
                />
              </div>
              
              {/* Dropdown */}
        <div className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-1 transition-all duration-200 z-50 ${
          coursesOpen 
            ? 'opacity-100 visible translate-y-0' 
            : 'opacity-0 invisible -translate-y-2'
        }`}>
          <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-200 rotate-45"></div>
          
          <div className="bg-white border border-gray-200 rounded-md shadow-lg w-64 overflow-hidden">
            <div className="py-1">
              {/* Level 3 first */}
              <Link 
                to="/courses/vietnamese-nails" 
                className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
              >
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-pink-600 rounded-full"></div>
                  <div>
                    <h4 className="font-medium text-gray-900 text-sm">Level 3 in Nail Technology</h4>
                    <p className="text-xs text-gray-600">Bilingual training for UK professionals</p>
                  </div>
                </div>
              </Link>

              <Link 
                to="/courses/laser-and-light" 
                className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
              >
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <div>
                    <h4 className="font-medium text-gray-900 text-sm">Level 4 in Laser and Light</h4>
                    <p className="text-xs text-gray-600">Professional laser training</p>
                  </div>
                </div>
              </Link>

              <Link 
                to="/courses/tattoo-removal" 
                className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
              >
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                  <div>
                    <h4 className="font-medium text-gray-900 text-sm">Level 5 in Tattoo Removal</h4>
                    <p className="text-xs text-gray-600">CPD Available</p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Optional: keep Services overview */}
            <div className="border-t border-gray-100 px-2 py-2">
              <Link 
                to="/services" 
                className="block w-full text-center py-1 px-3 bg-gray-800 text-white rounded text-xs font-medium hover:bg-black transition-colors duration-200"
              >
                View All Courses
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <Link to="/contact" className="text-gray-800 hover:text-black transition-colors duration-200">CONTACT</Link>
    </div>
  </div>

  {/* Mobile Dropdown Toggle */}
  <div className="md:hidden flex justify-center pb-3">
    <button
      onClick={() => setMobileOpen(!mobileOpen)}
      className="text-sm border px-4 py-2 rounded text-gray-800 border-gray-600 hover:bg-gray-100 transition-colors duration-200"
    >
      {mobileOpen ? 'Close Menu' : 'Menu'}
    </button>
  </div>

  {/* Mobile Dropdown Nav */}
  {mobileOpen && (
    <div className="md:hidden bg-[#f7f6f3] border-t border-gray-200 px-6 py-4 flex flex-col items-center gap-3 text-sm font-medium">
      <Link to="/" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">HOME</Link>
      <Link to="/about" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">ABOUT US</Link>
      <div className="text-gray-800 font-medium">COURSES:</div>
      {/* Level 3 first */}
      <Link to="/courses/vietnamese-nails" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 3 in Nail Technology</Link>
      <Link to="/courses/laser-and-light" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 4 in Laser and Light</Link>
      <Link to="/courses/tattoo-removal" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 5 in Tattoo Removal</Link>
      <Link to="/contact" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">CONTACT</Link>
      <a
        href="mailto:admin@kentacademy.co.uk"
        className="inline-block border border-gray-800 text-gray-800 px-3 py-1 rounded hover:bg-gray-800 hover:text-white transition-colors duration-200"
      >
        Contact Us
      </a>
    </div>
  )}
</nav>

      {/* Header Section */}
      <section className="relative pt-44 pb-20 px-6 w-full">
        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-light">
              About <span className="font-semibold">Kent Academy</span>
            </h1>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-lg">
              Kent Academy is setting a new benchmark for beauty and aesthetics education in the UK. With industry-leading trainers, hands-on equipment, and tailored support, we empower professionals at every stage of their journey.
            </p>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <img src="/assets/Nails2.JPG" alt="Training Session" className="rounded-xl shadow-lg object-cover w-full h-80" />
          <div>
            <h2 className="text-3xl md:text-4xl font-light mb-6">
              Our <span className="font-semibold">Story</span>
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Founded by experienced educators and technicians, Kent Academy was born out of a desire to elevate the standards of beauty training. We saw a gap between classroom learning and real-world results, and set out to create a hands-on, accredited training experience that actually works.
            </p>
            <p className="text-gray-700 leading-relaxed">
              With over 30 years of combined experience in aesthetics and laser technology, our team designs and manufactures our own beauty machines, ensuring you learn on the latest professional-grade equipment.
            </p>
          </div>
        </div>
      </section>

      {/* Our Mission */}
      <section className="py-16 bg-[#f7f6f3] px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <h2 className="text-3xl md:text-4xl font-light mb-6">
              Our <span className="font-semibold">Mission</span>
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              To provide every learner — whether beginner or advanced — with the tools, training, and confidence to build a successful career in beauty. We believe that education should be accessible, professional, and rooted in practice.
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                <p className="text-gray-700">Flexible training options to suit your schedule</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                <p className="text-gray-700">Bilingual support for Vietnamese-speaking learners</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                <p className="text-gray-700">Real equipment and salon-grade practice facilities</p>
              </div>
            </div>
          </div>
          <div className="relative order-1 md:order-2">
            <img 
              src="/assets/Laser1.jpg" 
              alt="Professional Training Environment" 
              className="w-full h-80 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-light text-center mb-12">
            Why Choose <span className="font-semibold">Kent Academy?</span>
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Fully Accredited Training',
                description: 'Accredited training across multiple beauty disciplines with nationally recognized qualifications'
              },
              {
                title: 'Bilingual Support',
                description: 'Support for English and Vietnamese-speaking learners with experienced tutors'
              },
              {
                title: 'Council Requirements',
                description: 'Courses aligned to council and licensing requirements for professional practice'
              },
              {
                title: 'Professional Equipment',
                description: 'Real equipment and salon-grade practice with cutting-edge technology'
              },
              {
                title: 'Flexible Learning',
                description: 'Flexible study options including weekends and one-on-one training'
              },
              {
                title: 'Expert Trainers',
                description: 'Expert trainers with over 30 years of field experience and industry knowledge'
              }
            ].map((item, idx) => (
              <div
                key={idx}
                className="bg-[#f7f6f3] border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300"
              >
                <h3 className="font-semibold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-[#f7f6f3] text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h3 className="text-3xl md:text-4xl font-light mb-6">
            Ready to take the next step in your <span className="font-semibold">beauty career?</span>
          </h3>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Join hundreds of successful graduates who have transformed their careers with Kent Academy's professional training programs.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-gray-800 text-white px-8 py-3 rounded hover:bg-black transition-colors duration-200"
          >
            Contact Us Today
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#333] text-white py-12">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8 text-sm">
          <div>
            <img src="/assets/KaLogo.png" alt="Kent Academy" className="w-14 mb-3" />
            <p className="text-gray-300">
              Kent Academy delivers advanced beauty training with professional-grade equipment and expert guidance.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Courses</h4>
            <ul className="space-y-1 text-gray-400">
              <li>Level 4 in Laser and Light</li>
              <li>Level 5 in Tattoo Removal</li>
              <li>Vietnamese Nail Courses</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Contact</h4>
            <ul className="space-y-1 text-gray-400">
              <li>
                <a href="mailto:admin@kentacademy.co.uk" className="hover:text-gray-300 transition-colors duration-200">
                  admin@kentacademy.co.uk
                </a>
              </li>
              <li>General: 07548321022</li>
              <li>Vietnamese Courses: 07548321022</li>
              <li>Unit 10, Creative Quarter, Javelin Way, Ashford TN24 8FN</li>
              <li>
                <a
                  href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white hover:underline"
                >
                  <img src="/assets/facebook-icon.png" alt="Facebook" className="w-6 h-6" />
                  facebook.com/KentAcademy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 text-center text-xs text-gray-400">© 2025 Kent Academy. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default AboutUs;
